if (!customElements.get('component-discounts')) {
  customElements.define(
    'component-discounts',
    class Discounts extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          discountListItem: '.discounts__discount',
        };

        this.elements = {
          discountsRemove: this.querySelectorAll('.discounts__remove'),
        };

        this.registerEventListeners();
      }

      registerEventListeners() {
        this.elements.discountsRemove.forEach((button) => {
          button.addEventListener('click', this.onRemoveClick.bind(this));
        });
      }

      onRemoveClick(event) {
        event.preventDefault();

        const currentTarget = event.currentTarget || event.target;

        const discountCode = currentTarget.dataset.code;
        if (!discountCode) return;

        // Show loading state
        const closeIcon = currentTarget.querySelector('.icon-close');
        const spinner = currentTarget.querySelector('.loading__spinner');
        spinner?.classList?.remove('hidden');
        closeIcon?.classList?.add('hidden');

        currentTarget.disabled = true;

        addRemoveDiscountCodes([], [discountCode])
          .then((response) => {
            // Check if removed, code shouldnt be in the list anymore
            const result = response?.discount_codes || [];

            const isRemoved =
              result.filter((code) => String(code.code).toLowerCase() === String(discountCode).toLowerCase()).length ===
              0;

            if (isRemoved) {
              // Remove discount element from DOM
              const discountElement = currentTarget.closest(this.selectors.discountListItem);
              if (discountElement) {
                discountElement.remove();
              }
            }

            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'component-discounts-remove' });
          })
          .finally(() => {
            // Hide loading state on error
            spinner?.classList?.add('hidden');
            closeIcon?.classList?.remove('hidden');
            currentTarget.disabled = false;
          });
      }
    },
  );
}
